/**
 * Room (Raum) API Endpoints
 * Centralizes all room-related API calls. `id` = documentId.
 */
import type { AxiosResponse } from "axios";
import api from "../api";
import type { ApiListResponse, ApiResponse, EntityPayload, QueryParams } from "../../types/api";
import type { Raeume } from "../../types/entities";

export const roomApi = {
  getAll: (params: QueryParams = {}): Promise<ApiListResponse<Raeume>> =>
    api.get("/api/raeumes", { params }),

  getById: (id: string, params: QueryParams = {}): Promise<ApiResponse<Raeume>> =>
    api.get(`/api/raeumes/${id}`, { params }),

  create: (data: EntityPayload): Promise<ApiResponse<Raeume>> => api.post("/api/raeumes", { data }),

  update: (id: string, data: EntityPayload): Promise<ApiResponse<Raeume>> =>
    api.put(`/api/raeumes/${id}`, { data }),

  delete: (id: string): Promise<AxiosResponse> => api.delete(`/api/raeumes/${id}`),
};
